import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

const { green, red } = colorsPalettes;

const Label = styled.label<{ color: string }>`
    ${({ color }) => setFontVariant("input2", color)};
`;

export const AboveAverage = () => <Label color={green["s100"]}>{translate("common.above.average")}</Label>;
export const BelowAverage = () => <Label color={red["s100"]}>{translate("common.below.average")}</Label>;
